import { useEffect, useRef, useState } from 'react';
import { Calendar } from 'react-date-range';
import { format } from 'date-fns/format';
import { isValid } from 'date-fns/isValid';
import { parse } from 'date-fns/parse';

function parseDisplayValue(value) {
  if (!value || typeof value !== 'string') return new Date();
  const mdy = parse(value, 'M/d/yyyy', new Date());
  if (isValid(mdy)) return mdy;
  const mdy2 = parse(value, 'MM/d/yyyy', new Date());
  return isValid(mdy2) ? mdy2 : new Date();
}

/**
 * Single calendar date (store wall date string M/D/YYYY) + TimePicker companion.
 * Drop-in for legacy `DatePicker` schedule fields; calls `onChange(dateName, 'M/D/YYYY')`.
 */
export default function StoreSingleDatePicker(props) {
  const {
    value,
    onChange,
    inputClass,
    containerClass,
    dateName,
    submitting,
    placeholder,
    showCalendar,
    spaceElement: _spaceElement,
    style,
  } = props;
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const calendarDate = parseDisplayValue(value);

  useEffect(() => {
    if (!open) return;
    const fn = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', fn);
    return () => document.removeEventListener('mousedown', fn);
  }, [open]);

  const commit = (d) => {
    const s = `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
    onChange(dateName, s);
    setOpen(false);
  };

  return (
    <div
      ref={rootRef}
      className={`store-single-date-filter date-picker-container ${containerClass || ''}`}
      style={style || {}}
    >
      <div
        className="date-picker__input-container"
        onClick={() => {
          if (!submitting) setOpen((o) => !o);
        }}
      >
        {showCalendar !== false && <i className="fa-solid fa-calendar-days date-picker__calendar" />}
        <input
          className={`${inputClass || ''} date-picker__input`}
          name={dateName}
          readOnly
          disabled={submitting}
          placeholder={placeholder}
          value={value}
        />
      </div>
      {open && !submitting && (
        <div className="store-single-date-popover">
          <Calendar
            date={calendarDate}
            onChange={commit}
            displayMode="date"
            showDateDisplay={false}
            months={1}
            direction="vertical"
            weekStartsOn={1}
            color="#F8A305"
          />
        </div>
      )}
    </div>
  );
}
